import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./modules/home/home.component";
import { PageNotFoundComponent } from "./modules/page-not-found/page-not-found.component";
import { AccountComponent } from "./modules/account/account.component";
import { CaseComponent } from "./modules/case/case.component";
import { ClinicVisitsComponent } from "./modules/clinic-visits/clinic-visits.component";
import { DemographicsComponent } from "./modules/demographics/demographics.component";
import { SickLeaveComponent } from "./modules/sick-leave/sick-leave.component";
import { TravelComponent } from "./modules/travel/travel.component";
import { ReportComponent } from "./modules/report/report.component";
import { PortalComponent } from "./modules/portal/portal.component";
import { ClinicalTestingComponent } from "./modules/clinical-testing/clinical-testing.component";
import { Covid19Component } from "./modules/covid19/covid19.component";
import { ConfidentialityAgreementComponent } from "./modules/confidentiality-agreement/confidentiality-agreement.component";
import { DirectivesComponent } from './modules/directives/directives.component';
import { F621CF848DF74452Component } from "./modules/f621-cf848-df74452/f621-cf848-df74452.component";
import { ImmunizationsComponent } from "./modules/immunizations/immunizations.component";
import { MainComponent } from "./modules/main/main.component";
import { TravelClearanceComponent } from "./modules/travel-clearance/travel-clearance.component";
import { ScoConfidentialityAgreementComponent } from "./modules/sco-confidentiality-agreement/sco-confidentiality-agreement.component";
import { UserGuideComponent } from "./modules/user-guide/user-guide.component";

const routes: Routes = [
  //{ path: "", component: HomeComponent, pathMatch: "full" },
  { path: "", component: MainComponent, pathMatch: "full" },
  { path: "userguides", component: UserGuideComponent },
  //{ path: "covid19", component: Covid19Component },
  { path: "confidentialityagreement", component: ConfidentialityAgreementComponent },
  { path: "scoconfidentialityagreement", component: ScoConfidentialityAgreementComponent },
  { path: "directives", component: DirectivesComponent },
  { path: "F621CF848DF74452", component: F621CF848DF74452Component },
  { path: "immunizations", component: ImmunizationsComponent },
  { path: "account", component: AccountComponent },
  //{ path: "case", component: CaseComponent },
  // { path: "clinicvisits", component: ClinicVisitsComponent },
  // { path: "clinicaltesting", component: ClinicalTestingComponent },
  // { path: "demographics", component: DemographicsComponent },
  // { path: "sickleave", component: SickLeaveComponent },
  //{ path: "travel-clearance", component: TravelClearanceComponent },
  { path: "travel", component: TravelComponent },
  // { path: "report", component: ReportComponent },
  { path: "portal", component: PortalComponent },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
